export default "__VITE_ASSET__242e98b4__"